import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Home from './components/Home';
import Header from './components/Header';
import Footer from './components/Footer';
import About from './components/About';
import Events from './components/Events';
import Curriculum from './components/Curriculum';
import Enrolments from './components/Enrolments';
import ContactUs from './components/ContactUs';
import Documents from './components/Documents';
import Careers from './components/Careers'; 
import Team from './components/Team'; 
import AdminDashboard from './components/AdminDashboard';
import CreateEvent from './components/createEvent';
import EditEvent from './components/editEvent';
import AdminInquiries from './components/AdminInquiries';
import AdminUpdates from './components/AdminUpdates';
import RouteBackground from './components/RouteBackground';
import ServicesUsed from './components/ServicesUsed';
import PublishJobs from './components/publishJobs';
import AdminInterests from './components/AdminInterests';
import AdminApprovals from './components/AdminApprovals';
import AdminEvents from './components/AdminEvents';
import ContactIT from './components/ContactIT';
import Maintenance from './components/Maintenance';
import AdminJobApplications from './components/AdminJobApplications';
import AdminManageJobs from './components/AdminManageJobs';
import EventDetail from "./components/EventDetail";

import Error404 from './components/Error404';
import Error403 from './components/Error403';

import './App.css';
import './styles/themes.css';
import { API_BASE } from './lib/apiBase';

function App() {
  const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);
  const [maintenanceChecked, setMaintenanceChecked] = useState(false);

  useEffect(() => {
    let ignore = false;

    const fetchStatus = async () => {
      try {
        const res = await fetch(`${API_BASE}/meta/maintenance`);
        if (!res.ok) throw new Error('Failed to fetch maintenance status');
        const data = await res.json();
        if (!ignore) {
          setMaintenanceEnabled(Boolean(data?.enabled));
        }
      } catch (err) {
        console.error('Failed to fetch maintenance status', err);
      } finally {
        if (!ignore) {
          setMaintenanceChecked(true);
        }
      }
    };

    fetchStatus();

    const interval = setInterval(fetchStatus, 60 * 1000);

    const handleMaintenanceEvent = (event) => {
      if (typeof event.detail?.enabled === 'boolean') {
        setMaintenanceEnabled(Boolean(event.detail.enabled));
        setMaintenanceChecked(true);
      }
    };

    window.addEventListener('maintenance-mode-changed', handleMaintenanceEvent);

    return () => {
      ignore = true;
      clearInterval(interval);
      window.removeEventListener('maintenance-mode-changed', handleMaintenanceEvent);
    };
  }, []);

  const withMaintenanceGuard = (element) => {
    if (!maintenanceChecked) return element;
    return maintenanceEnabled ? <Maintenance /> : element;
  };

  return (
    <Router>
      <RouteBackground />
      <Header />
      <main style={{flex: 1}}>
      <Routes>

        <Route path="/" element={withMaintenanceGuard(<Home />)} />
        <Route path="/enrolments" element={withMaintenanceGuard(<Enrolments />)} />
        <Route path="/curriculum" element={withMaintenanceGuard(<Curriculum />)} />
        <Route path="/about" element={withMaintenanceGuard(<About />)} />
        <Route path="/contact" element={withMaintenanceGuard(<ContactUs />)} />
        <Route path="/events" element={withMaintenanceGuard(<Events />)} />
        <Route path="/events/:id" element={withMaintenanceGuard(<EventDetail />)} />
        <Route path="/careers" element={withMaintenanceGuard(<Careers />)} />
        <Route path="/documents" element={withMaintenanceGuard(<Documents />)} />
        <Route path="/team" element={withMaintenanceGuard(<Team />)} />
        <Route path="/maintenance" element={<Maintenance />} />

        <Route path="/a7dash87" element={<AdminDashboard />} />
        <Route path="/a7dash87/create-event" element={<CreateEvent />} />
        <Route path="/a7dash87/edit-event/:id" element={<EditEvent />} />
        <Route path="/a7dash87/inquiries" element={<AdminInquiries />} />
        <Route path="/a7dash87/updates" element={<AdminUpdates />} />
        <Route path="/a7dash87/services-used" element={<ServicesUsed />} />
        <Route path="/a7dash87/publish-jobs" element={<PublishJobs />} />
        <Route path="/a7dash87/interests" element={<AdminInterests />} />
        <Route path="/a7dash87/manage-jobs" element={<AdminManageJobs />} />
        <Route path="/a7dash87/events" element={<AdminEvents />} />
        <Route path="/a7dash87/approvals" element={<AdminApprovals />} />
        <Route path="/a7dash87/contact-it" element={<ContactIT />} />
        <Route path="/a7dash87/job-applications" element={<AdminJobApplications />} />

        <Route path='*' element={withMaintenanceGuard(<Error404 />)} />
        <Route path='/403' element={<Error403 />} />

      </Routes>
      </main>
      <Footer />
    </Router>
  );
}

export default App;
